'use strict'

var React = require('react');
const ReactRedux = require('react-redux');
let BaseComponent = require('../shared/base');
const CommonModule = require('../../public/js/common');
const EnumCoreModule = require('../../public/js/enum-core');
let client = require('../../../sdk/client');
if (typeof window !== 'undefined') {
    require('../../public/js/bepensa/JQBlockUI');
}

var Toastr = require('toastr');
let descHeader1 = "Esta sección esta diseñada para facilitar la compra masiva de artículos. Copia y pega desde un Excel las filas con columnas: número de parte y cantidad.";
let descHeader2 = " Al terminar pulse el botón Validar Carrito."

class Item {
    itemId
    numPart
    stock
    description
    name
    antecesor
    sucesor
    type
    qty
    numPartAntecesor
    numPartSucesor
    isDeleted = false
    priceLista
    priceCore
    priceCoreCF
    priceUnit
    salesUnit
    itemType = new ItemType()



    getQuantity() {

        if (this.boolIsSameSucesor()) {
            return this.qty
        }

        if (this.type == this.itemType.sucesor) {
            return this.qty;
        } else if (this.stock > this.qty) {
            return this.qty;
        }
        return this.stock;

    }

    boolSugSucesor() {

        if (this.type == this.itemType.antecesor && this.qty > this.stock) {
            return true;
        }

        return false;
    }

    boolIsSameSucesor() {

        return this.numPart == this.sucesor.numPart && this.type == this.itemType.sucesor;
    }

    boolIsAntecesor() {

        return this.type == this.itemType.antecesor;
    }

    boolIsSupercesor() {

        return this.type == this.itemType.sucesor;
    }

    boolIsAntecesorStockEmpty() {

        return !(this.boolIsAntecesor() && this.stock > 0);
    }

    boolIsSucesor() {
        return this.qty > this.stock ? true : false;
    }

    boolSugAntecesor() {

        if (this.type == this.itemType.sucesor && this.qty > this.stock && this.antecesor != undefined && this.antecesor.stock > 0) {
            return true;
        }

        return false;

    }

    boolShowSugSucesor() {
        return this.qty > this.stock ? true : false;
    }

    quantitySugSucesor() {

        return Math.abs(this.qty - this.stock);


    }

    quantitySugAntecesor() {

        if (this.stock == 0) {

            if(this.qty < this.antecesor.stock){
                
                return this.qty 
            
            }else if (this.antecesor.stock > this.qty) {

                return this.antecesor.stock - this.qty;

            }
            
            return this.antecesor.stock;;
        }

        var dif = this.qty - this.stock;
        return this.antecesor.stock > dif ? dif : this.stock;

    }
}

class ItemType {
    sucesor = "sucesor"
    antecesor = "antecesor"
}

const codeAntecesor = process.env.CF_ANTECESOR;
const codeSucesor = process.env.CF_SUPERCESOR;
const codeUnitSales = process.env.CF_SALES_UNIT;
const nameCore = "Precio Core";
const nameCurrency = "Currency";

class OrderAgilComponent extends BaseComponent {

    constructor(props) {
        super(props)

        this.state = {
            inputData: [],
            arrDuplicate: [],
            arrayItemsIssues: [],
            boolShowTable: false,
            taValue: "",
            headerItem: "",
            titleModal: "",
            arrayItems: [],
            issuesIsEmpty: true,
            deleteitems: false
        }
        this.responses = { sucesores: null, antecesores: null },
        this.ItemType = new ItemType();
        this.sucursales = [];
        this.userConfig = [];
        this.disponibilidadAlmacenes = "";
        this.arrOfNumParts = []; 
        this.boolIsNewItem = false;
        
        this.handleChange = this.handleChange.bind(this);
        this.packageIdAlmacenes = process.env.ADMINISTRACION_ALMACENES;
    }

    componentDidMount() {

        if (typeof window !== 'undefined') {
            var $ = window.$;
        }

        if (typeof this.props.user === 'undefined') {

            this.showMessage(EnumCoreModule.GetToastStr().Error.SESION_NO_INICIADA);
            window.location = "/";
        }

        if (this.props.user && this.props.user.Guest === true && CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
            this.props.user.ID = CommonModule.getCookie("guestUserID");
        }

        //Check address Id from cookies
        this.getAddressIdFromCookies();

        this.loadSucursales();

        $("#textarea").on("change keyup paste", function () {

            if ($('#textarea').val() != "") {
                $('.btn-initial').css('cssText', 'background:#28A745 !important')
            } else {
                $('.btn-initial').css('cssText', 'background:#888888 !important')
            }

        })

    }

    handleChange(event) {
        this.setState({ taValue: event.target.value });
    }

    getDataTable(e) {

        var aux = document.getElementById('textarea').value;

        if (!aux.includes("\t") || aux == "") {
            Toastr.warning('Favor de ingresar No. de parte y cantidad con el formato especificado.', 'Sugerencia');
            document.getElementById('textarea').value = "";
            $('.btn-initial').css('cssText', 'background:#888888 !important')
            return;
        }

        $('#tablemain tbody').empty();

        var items = this.state.taValue.split('\n');
        for (let i = 0; i < items.length; i++) {
            if(items[i].trim() != ""){
                let item = items[i].split('\t');

                if (item.length <= 2) {
                    //continue;                
    
                    if (this.state.arrDuplicate.includes(item[0].trim())) {
    
                    } else {
    
                        var numPart = item[0].trim();
                        numPart = numPart.replaceAll(",", "");
    
                        if (numPart.includes(" ")) {
                            Toastr.warning('Favor de ingresar No. de parte con el formato especificado.', 'Sugerencia');
                            document.getElementById('textarea').value = "";
                        }
    
                        document.getElementById("inputdata").style.display = 'none';
                        document.getElementById("tableData").style.display = 'flex';
                        //numPart = numPart.replaceAll(" ", "");
                        var inputQty = (item[1] == undefined || item[1] == '') ? '1' : item[1];
                        var qty = parseInt(inputQty);
    
                        this.state.inputData.push({
                            numPart: numPart.toUpperCase(),
                            qty: qty
                        });
    
                        var fila = "<tr><td className ='text-center'>" + numPart + "</td><td>" + inputQty + "</td></tr>";
                        var tr = document.createElement("tr");
    
                        tr.innerHTML = fila;
                        $('#tablemain tbody').append(tr);
    
                        this.state.arrDuplicate.push(numPart);
                    }
            }
            
            } else {
                //Toastr.warning('Favor de ingresar los datos con el formato especificado.', 'Sugerencia');;
                document.getElementById('textarea').value = "";
                return;

            }
        }
    }

    validateItems(arrInputData) {

        //Block UI 
        $.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Procesando números de parte...' });
        
        this.userAddress = this.getCookie('SelectedAddress');
        let currency = $("#exchange-currency").attr("currency");

        let arrRequests = [];
        var numPart = "";
        
        this.setState({
            arrayItemsIssues: []
        });

        for (let i = 0; i < arrInputData.length; i++) {

            numPart = arrInputData[i].numPart;
            arrRequests.push(client.OrderAgil.getItems(numPart.trim()));
        }
        var items = [];
        Promise.all(arrRequests).then(arrResponse => {

            var response = arrResponse[0];
            let arrSucesoresRequest = [];
            let arrAntecesoresRequest = [];
            let arrNotFound = [];

            arrResponse.forEach((element, index) => {

                var itemRequest = element[0];
                var item = new Item();
                if (itemRequest != undefined) {

                    var foundAnt = itemRequest.CustomFields.filter(function (item) { return item.Code === codeAntecesor; });
                    var foundSuc = itemRequest.CustomFields.filter(function (item) { return item.Code === codeSucesor; });
                    var foundUnit = itemRequest.CustomFields.filter(function (item) { return item.Code === codeUnitSales; });
                    
                    var valueAnt = foundAnt.length > 0 ? foundAnt[0].Values[0] : "";
                    var valueSuct = foundSuc.length > 0 ? foundSuc[0].Values[0] : "";
                    var valueUnit = foundUnit.length > 0 ? foundUnit[0].Values[0] : "";

                    var foundCore = itemRequest.CustomFields.filter(function (item) { return item.Name === nameCore; });
                    var foundCurrencyCode = itemRequest.CustomFields.filter(function (item) { return item.Name === nameCurrency; });
                 
                    var valueAnt = foundAnt.length > 0 ? foundAnt[0].Values[0] : "";
                    var valueSuct = foundSuc.length > 0 ? foundSuc[0].Values[0] : "";
                    var valueCore = foundCore.length > 0 ? foundCore[0].Values[0] : "0";
                    var valueCurrency = foundCurrencyCode.length > 0 ? foundCurrencyCode[0].Values[0] : "";
                   
                    arrSucesoresRequest.push(client.OrderAgil.getItems(valueSuct));
                    arrAntecesoresRequest.push(client.OrderAgil.getItems(valueAnt));

                    item.itemId = itemRequest.ID + "-salt-" + Math.floor(Math.random() * 100);
                    item.numPart = arrInputData[index].numPart.toUpperCase();
                    item.stock = 0;
                    item.description = itemRequest.BuyerDescription;
                    item.name = itemRequest.Name;
                    item.antecesor = undefined
                    item.sucesor = undefined
                    item.type = arrInputData[index].numPart == valueSuct ? this.ItemType.sucesor : this.ItemType.antecesor;
                    //Calcular cantidad respecto a unidad de venta
                    var qtyMultiple  = this.getQtyByMultiple(arrInputData[index].qty, valueUnit); 
                    item.qty = qtyMultiple;
                    item.numPartAntecesor = valueAnt;
                    item.numPartSucesor = valueSuct;
                    item.salesUnit = valueUnit;
                    if (itemRequest.Price != undefined && valueCurrency != undefined) {
                        item.priceLista = itemRequest.Price;
                        item.priceUnit = valueCurrency;
                    }
                    else {
                        item.priceLista = 0.00
                    }
                    item.priceCore = 0.00
                    
                    if(valueCurrency != "MXN"){
                        let price = parseFloat(valueCore) * currency;                      
                        item.priceCoreCF = "$" + this.subFormatMoney(price) + " MXN";
                    }else{
                        item.priceCoreCF = "$" + this.subFormatMoney(parseFloat(valueCore)) + " MXN";;
                    }
                   
                    items.push(item);

                    this.arrOfNumParts.push({ "partCode": item.numPart });

                } else {

                    item.numPart = arrInputData[index].numPart.toUpperCase();
                    item.qty = arrInputData[index].qty
                    item.type = "notfound"
                    item.stock = 0

                    arrNotFound.push(item);

                    if (this.state.arrayItemsIssues.length > 0) {
                        var auxItemIssues = this.state.arrayItemsIssues;

                        arrNotFound.forEach(element => {

                            var itemExist = this.state.arrayItemsIssues.find(item => item.numPart == element.numPart && item.isDeleted == false);

                            if (itemExist == undefined) {
                                auxItemIssues.push(element);
                            } else {

                            }

                        });

                        arrNotFound = auxItemIssues;
                    }
                    
                    if(this.boolIsNewItem){                       
                        $.unblockUI();
                    }                    
                    this.setState({
                        arrayItemsIssues: arrNotFound
                    });
                }

            });

            Promise.all(arrAntecesoresRequest).then(response => {
                this.responses.antecesores = response;

                Promise.all(arrSucesoresRequest).then(response => {
                    this.responses.supercesores = response;
                    items.forEach((item, index) => {
                        item.sucesor = this.parseItem(this.responses.supercesores[index][0], item.numPartSucesor, "sucesor");
                        item.antecesor = this.responses.antecesores[index].length > 0 ? this.parseItem(this.responses.antecesores[index][0], item.numPartAntecesor, "antecesor") : undefined;

                    });

                    this.processStock(items);

                }).catch(err => {
                    $.unblockUI();
                    toastr.error("Se ha detectado un error al procesar la petición, por favor inténtalo más tarde");
                });

            }).catch(err => {
                $.unblockUI();
                toastr.error("Se ha detectado un error al procesar la petición, por favor inténtalo más tarde");
            });
        }).catch(err => {
            $.unblockUI();
            toastr.error("Se ha detectado un error al procesar la petición, por favor inténtalo más tarde");
        });
    }

    getQtyByMultiple(qty, salesUnit){
        let qtyValue = 0; 
        let intInputValue = parseInt(qty);  
        salesUnit = parseInt(salesUnit);

        if (intInputValue == 0) {
            qtyValue = salesUnit;
            }
            else if (intInputValue > 0) {
                if (this.isMultiple(intInputValue, salesUnit)) {
                    qtyValue = intInputValue;
                } else {

                    if (intInputValue < salesUnit) {
                         qtyValue = salesUnit;
                    } else {
                        // Arrays que contendran los valores multiples de salesUnit
                        let multiples_salesUnit = [];
                        var aux = intInputValue * salesUnit;

                           for (var i = 1; i <= aux; i++) {
                            if (this.isMultiple(i, salesUnit)) {
                                multiples_salesUnit.push(i);
                            };

                            for (let index = 0; index < multiples_salesUnit.length; index++) {
                                const element = multiples_salesUnit[index];

                                if (intInputValue < element) {                                    
                                    qtyValue = element;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            return qtyValue;
    }

    parseItem(itemRequest, numPart = undefined, type) {

        if (itemRequest == undefined) {
            return undefined;
        }

        var item = new Item();
        var foundCore = itemRequest.CustomFields.filter(function (item) { return item.Name === nameCore; });
        var valueCore = foundCore.length > 0 ? foundCore[0].Values[0] : "0";
        let currency = $("#exchange-currency").attr("currency");
        var foundCurrency = itemRequest.CustomFields.filter(function (item) { return item.Name === nameCurrency; });
        var valueCurrency = foundCurrency.length > 0 ? foundCurrency[0].Values[0] : "0";
        
        item.itemId = itemRequest.ID + "-salt-" + Math.floor(Math.random() * 100);
        item.numPart = numPart;
        item.stock = 0;
        item.description = itemRequest.BuyerDescription;
        item.name = itemRequest.Name;
        item.antecesor = undefined
        item.sucesor = undefined
        item.type = type
        item.qty = 0
        if (itemRequest.Price != undefined && valueCurrency != undefined) {
            item.priceLista = itemRequest.Price;
            item.priceUnit = valueCurrency;
        }
        else {
            item.priceLista = 0.00
        }
        item.priceCore = 0.00

        if(valueCurrency != "MXN"){
            let price = parseFloat(valueCore) * currency;                      
            item.priceCoreCF = "$" + this.subFormatMoney(price) + " MXN";
        }else{
            item.priceCoreCF = "$" + this.subFormatMoney(parseFloat(valueCore)) + " MXN";;
        }

        return item;
    }

    processStock(arrayitems) {

        var promiseStock = [];
        var promiseStockAux = [];
        let arrayParts = [];

        for (let index = 0; index < arrayitems.length; index++) {
            const element = arrayitems[index];
            var numItem = { "partCode": element.numPart };

            arrayParts.push(numItem);

            if (element.antecesor != undefined) {
                var numItemAntecesor = { "partCode": element.antecesor ? element.antecesor.numPart : '' };
                arrayParts.push(numItemAntecesor);
            }

            if (element.sucesor != undefined) {
                var numItemSucesor = { "partCode": element.sucesor ? element.sucesor.numPart : '' };
                arrayParts.push(numItemSucesor);
            }

        }

        this.processStockItemPromise2(arrayParts).then(response => {
          //  console.log("Bllock UI")
          //  console.log(response)
            var numItemsResponse = response[0].Parts;

            arrayitems.forEach((item, index) => {

                var stockMain = numItemsResponse.find(i => item.numPart == i.PartCode);
                if (stockMain != undefined) {
                    item.stock = this.getStockTotal(stockMain);
                }

                if (item.antecesor != undefined) {
                    var stockAntecesor = numItemsResponse.find(i => item.antecesor.numPart == i.PartCode);
                    item.antecesor.stock = this.getStockTotal(stockAntecesor);
                }
                if (item.sucesor != undefined) {
                    var stockSucesor = numItemsResponse.find(i => item.sucesor.numPart == i.PartCode);
                    item.sucesor.stock = this.getStockTotal(stockSucesor);
                }


            });

            let arrFound = arrayitems;

            if (this.state.arrayItems.length > 0) {
                var auxItem = this.state.arrayItems;


                arrFound.forEach(element => {

                    var itemExist = this.state.arrayItems.find(item => item.numPart == element.numPart);

                    if (itemExist == undefined) {
                        auxItem.push(element);
                    } else {
                        //Unlock the view
                        $.unblockUI();
                        Toastr.warning('El No. de parte ya se encuentra agregado.', 'Duplicación de registro');
                    }
                });
                arrFound = auxItem;
            }

            this.setState({
                arrayItems: arrFound,
                deleteitems: false,
                boolShowTable: true
            });

            this.loadSalePrices().then(response => {                
                console.log(response);
                //Unlock the view
                $.unblockUI();
            });

        });      

    }

    processStockItemPromise2(arrNumPartes) {

        return new Promise((resolve, reject) => {

            const requestBody = {
                "operatingUnitId": 446,
                "partsCode": arrNumPartes
            };

            const promiseapilider = client.Availability.GetAvalability(requestBody);

            Promise.all([promiseapilider]).then(response => {
                if (response != null && response[0].Result == 0) {
                    resolve(response)
                } else {
                    $.unblockUI();
                    Toastr.error("No. de parte no encontrada, favor de revisar la lista");
                    document.getElementById("inputdata").style.display = 'block';
                    document.getElementById("tableData").style.display = 'none';
                }

            });
        });
    }

    getStockTotal(response) {

        if (this.userConfig.length > 0 && response != undefined/*&& response[1].parts.length > 0*/) {
            let liderPart = response; // debe ser solo una porque se busca sdolamente esta
            this.disponibilidadAlmacenes = response.Availabilitys;


            var exist = this.userConfig.find(config => config.AddressId == this.state.strCookieAddressId);

            if (exist) {
                this.extendAvailability = exist.VisibilidadExistenciasLiderId.split(','); // generate array of lider id.
            }

            this.hasUserConfig = true;

        } else if (this.userConfig.length == 0 && response != undefined) {
            this.disponibilidadAlmacenes = response.Availabilitys;
            this.hasUserConfig = false;
        }

        var stockTotal = 0;
        this.sucursales.forEach(element => {
            let stock = this.getStockAvailabilityCF(element.LiderId);

            stockTotal += stock;
        });

        return stockTotal;
    }

    UserIsOnlyLookup(user) {

        let isOnlyLookup = false;

        if (user.CustomFields != null) {
            let cfConsulta = user.CustomFields.find(x => x.Code == process.env.CF_CLIENTE_CONSULTA);
            if (cfConsulta != undefined) {
                if (cfConsulta.Values.length > 0) {
                    let value = cfConsulta.Values[0];

                    if (value == "SI") {
                        isOnlyLookup = true;
                    } else if (value == "NO") {
                        isOnlyLookup = false;
                    }


                }
            }

        }

        return isOnlyLookup;
    }

    subDummyCallback() {
        setTimeout(() => {
            Toastr.success("Números de parte agregados con éxito!");
        }, 5000)

        setTimeout(() => {
            Toastr.info("Redirigiendo a carrito de compra...");
            window.location = '/cart';
        }, 10000);
    }

    addItemsCar(e) {
        //Si no existen registros regresa a la pantalla principal.
        if ((this.state.arrayItems.length === 0)
            && (this.state.arrayItemsIssues.length === 0)) {
            window.location = "/pedido-agil";

        };

        /*let lookupUser = this.UserIsOnlyLookup(this.props.user);
        if (lookupUser) {
            Toastr.warning('Tu usuario es solo para consulta no puedes agregar al carrito', 'Usuario de Consulta');
        }
        else {*/
            var datosTable = document.getElementById("dataOk").rows.length;
            let arrCant = [];
            let priceError = false;
            var userGuid = this.props.user.ID;

            if (userGuid.length) {
                if (datosTable > 1) {

                    var table = document.getElementById("dataOk");
                    var rows = table.getElementsByTagName("tr");
                    let promiseCart = [];
                    let dataCart = [];
                    for (var i = 1; i < rows.length; i++) {
                        var currentRow = table.rows[i];
                        var cell = currentRow.getElementsByTagName("td")[2];
                        var cellPrice = currentRow.getElementsByTagName("td")[4];
                        var cellNumber = currentRow.getElementsByTagName("td")[0];
                        var qty = cell.innerHTML;
                        var priceItem = cellPrice.innerHTML;
                        var numParte = cellNumber.innerHTML;
                        numParte = numParte.toUpperCase();
                        qty = cell.getElementsByTagName("input")[0].value;
                        var idItem = currentRow.getAttribute("id");
                        let cant = parseInt(qty)                        
                        dataCart.push({ "idItem": idItem, "qty": cant, "numPart": numParte});

                        if (priceItem != "") {
                            //Block UI 
                            $.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: '' });
                            $('#passCar').prop("disabled", false);

                            arrCant.push(cant);

                            if (arrCant.includes(0)) {
                                Toastr.warning('No se puede procesar piezas con cantidad en cero.', 'Advertencia');
                                $.unblockUI();
                                return;
                            }

                        }
                        else {
                            priceError = true;
                        }
                    }

                    if (priceError) {
                        Toastr.warning('No se puede procesar piezas con precio en cero.', 'Advertencia');
                        $('#passCar').prop("disabled", true);
                        //Unlock the view
                        $.unblockUI();
                    }
                    // add recursive                    
                    this.addAllItemsToCart(true, 0, userGuid, dataCart);                  
                   
                }
                else {
                    //  alert("Debes agregar elementos para continuar")
                    Toastr.warning('Favor de agregar elementos para continuar.', 'Sugerencia');
                    //Unlock the view
                    $.unblockUI();
                }
            } else {
                //  alert('Debes iniciar sesion o crear una cuenta');
                Toastr.warning('Favor de iniciar sesión o crear una cuenta para continuar.', 'Sugerencia');
            }
        //}
    }

    addAllItemsToCart(
        boolStartProcess_I, intNextIndex_I, userGuid, arrDataCart
    ) {
        let self = this;
        if (
            boolStartProcess_I
        ) {
            $('#blockMessage').text(`Agregando a carrito...`);
            $.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: $('#blockMessage') });
        }
        else {
            //Update progress
            $('#blockMessage').text(`Agregando a carrito (${(intNextIndex_I + 1)}/${arrDataCart.length})...`);
            //$.blockUI({ css: { backgroundColor: '#D1D2D4' }, message:  $('#blockMessage')});
        }

        let strCartId = arrDataCart[intNextIndex_I].idItem.split('-salt-')[0];
        let strCartQty = arrDataCart[intNextIndex_I].qty;
        let arrNumbers = [];
        let strCartNumber = arrDataCart[intNextIndex_I].numPart;
        let strLength = arrDataCart.length;
        let arrDataCartAux = arrDataCart;  
        /* Test 
        if(strCartNumber == "4955518"){
            strCartId = "#%#$";
        }*/
       
            client.Carts.addCart({
                userId: userGuid,
                quantity: strCartQty,
                discount: "",
                itemId: strCartId,
                force: false,
                forComparison: false
            },
                function (err, cartAddResponse) {
                    if(!err){
                        if (
                            (intNextIndex_I + 1) == strLength
                        ) {
                            window.location = '/cart'
                        }
                        else {
                            self.addAllItemsToCart(false, intNextIndex_I + 1, userGuid, arrDataCart);
                        }
                    }else{   
                        
                        for (let index = 0; index < arrDataCartAux.length; index++) {
                            const element = arrDataCartAux[index];
                            if(strCartNumber == element.numPart){  
                                for (let indexInterno = index; indexInterno < arrDataCartAux.length; indexInterno++) {
                                    const elementInterno = arrDataCartAux[indexInterno];
                                    arrNumbers.push({"numPart": elementInterno.numPart, "qty": elementInterno.qty});                                    
                                }
                            }                            
                        }  
                        Toastr.error('Ocurrió un error al realizar la petición', 'Servicio no disponible');
                        var table = document.getElementById("import-error-table").getElementsByTagName('tbody')[0]; 
                        table.innerHTML = '';
                        self.fillTableErrors(arrNumbers);
                    }
                });                
    } 
   


    addCarPromise(userGuid, cant, idItem) {

        return new Promise((resolve, reject) => {
            const options = {
                userId: userGuid,
                quantity: cant,
                discount: "",
                itemId: idItem,
                force: false,
                forComparison: false
            };


            client.Carts.addCart(options, function (err, result) {
                if (err) {

                }
                else {
                    resolve(result);
                }
            });
        });
    }

    showDeleteRow(
        //                                                  //Muestra el modal de confirmacion para eliminar items
        //                                                  //      que si existen.

        //                                                  /ID del item a eliminar de la lista (tabla).
        id
    ) {

        this.setState({
            selectedItemToDelete: id
        }, function () {
            $('#modalRemove').modal('show');
        });
    }

    doItemDelete(
        //                                                  //Elimina los items que si se encontraron y si existen.
        //                                                  //Se utiliza el id del item.

    ) {
        var rowDelete = this.state.selectedItemToDelete;
        let arrayAux = this.state.arrayItems;
        var intIndex = -1;
        var intFlag = -1;   //-1 No encontrado, 0 Coincidencia en item, 1 Concidencia en item.sucesor, 2 Coincidencia en item.antecesor

        for (let index = 0; index < arrayAux.length; index++) {
            const item = arrayAux[index];
            if (item.itemId == rowDelete) {

                intIndex = index;
                intFlag = 0;
                break;

            } else if (item.sucesor != undefined && item.sucesor.itemId == rowDelete) {

                intIndex = index;
                intFlag = 1;
                break;

            } else if (item.antecesor != undefined && item.antecesor.itemId == rowDelete) {

                intIndex = index;
                intFlag = 2;
                break;
            }
        }

        if (intIndex >= 0) {

            switch (intFlag) {
                case 0:
                    arrayAux[intIndex].isDeleted = true;
                    break;
                case 1:
                    arrayAux[intIndex].sucesor.isDeleted = true;
                    break;
                case 2:
                    arrayAux[intIndex].antecesor.isDeleted = true;
                    break;

                default:
                    break;
            }

            this.setState({
                arrayItems: arrayAux

            }, function () {
                $('#modalRemove').modal('hide');
                $('#modalRemoveFromPedidoUnit').modal('hide');     
                this.forceUpdate();           
            });


        }
    }


    showDeleteRoIssues(
        //                                                  //Muestra el modal de confirmacion para eliminar items
        //                                                  //      que no existen.

        //                                                  //Numero de parte del item a eliminar de la lista (tabla).
        numPart
    ) {

        this.setState({
            selectedItemToDeleteIs: numPart
        }, function () {
            $('#modalRemoveI').modal('show');
        });
    }

    doItemDeleteIssues(
        //                                                  //Elimina los items que no se encontraron y que 
        //                                                  //    posiblemente no existan con ese numero de parte.
        //                                                  //Se utiliza el numero de parte porque no tienen un Id.

    ) {

        var rowDelete = this.state.selectedItemToDeleteIs;
        let arrayAux = this.state.arrayItemsIssues;
        var intIndex = -1;

        arrayAux.forEach((item, index) => {

            if (item.numPart == rowDelete) {

                intIndex = index;

            }

        });

        if (intIndex >= 0) {
            arrayAux[intIndex].isDeleted = true;
            this.setState({
                arrayItemsIssues: arrayAux

            }, function () {
                $('#modalRemoveI').modal('hide');
            });


        }

    }
    showDeleteItemModalConfimationUnit(
        strInputId_I, 
        )
    {  
         this.setState({
            selectedItemToDelete: strInputId_I
        }, function () {
            $('#modalRemoveFromPedidoUnit').modal('show');
        });
               
    }


    showItemAddEdit(
        //                                                  //Muesta modal para editar items no encontrados y 
        //                                                  // volverlos a consultar para validar si existen.
        itemId, itemNum, qty, flag, type
    ) {

        if (flag == "add") {
            $('#num_parte').val("");
            $('#qtyedit').val(0);
            $('#modal-add-edit-item').modal('show');

            this.setState({
                titleModal: "Agregar nuevo producto al pédido ágil"
            });

        }
        if (flag == "move") {
            $('#num_parteant').val(itemNum);
            var qtyActual = $("#qty-" + itemId).val();
            $('#qtyeditant').val(qtyActual);
            $('#modal-add-edit-item-ant').modal('show');
        }
        else if (flag == "edit") {
            $('#num_parte').val(itemNum);
            $('#qtyedit').val(parseInt(qty));
            $('#modal-add-edit-item').modal('show');
        }



        this.setState({
            titleModal: "Edición de registro de Pedido ágil",
        });
    }


    existItemAntecesor(e) {

        var numpart = $('#num_parteant').val().trim();
        numpart = numpart.replaceAll(",", "");
        var qty = $('#qtyeditant').val();
        $('#btn-valregant').prop("disabled", false);

        if (numpart == "" || qty == 0) {
            Toastr.warning('Completa los campos para validar registro', 'Campos requeridos');
            return;

        }

        if (this.state.arrayItemsIssues.find(item => item.numPart == numpart)) {
            Toastr.warning('El No. de parte ya se encuentra agregado.', 'Duplicación de registro');
            return
        }

        if (this.state.arrayItems.find(item => item.numPart == numpart)) {
            Toastr.warning('El No. de parte ya se encuentra agregado.', 'Duplicación de registro');
            return
        }

        let arrayAux = this.state.arrayItems;
        let priceUnitario = 0;
        this.getPriceUnitario(numpart).then(response =>{
        if(response != undefined || response != null){
            priceUnitario = response
        }
        
        var intIndex = -1;
        var intFlag = -1;   //-1 No encontrado, 0 Coincidencia en item, 1 Concidencia en item.sucesor, 2 Coincidencia en item.antecesor

        arrayAux.forEach((item, index) => {

            if (item.numPart == numpart) {
                intIndex = index;
                intFlag = 0;

            } else if (item.sucesor != undefined && item.sucesor.numPart == numpart) {

                intIndex = index;
                intFlag = 1;

            } else if (item.antecesor != undefined && item.antecesor.numPart == numpart) {

                intIndex = index;
                intFlag = 2;
            }

        });
        
        const newItem = new Item();
        var itemToPush = null;  
        
            if (intIndex >= 0) {

                newItem.itemId = arrayAux[intIndex].itemId;
                newItem.numPart = arrayAux[intIndex].numPart;
                newItem.stock = arrayAux[intIndex].stock;
                newItem.description = arrayAux[intIndex].description;
                newItem.name = arrayAux[intIndex].name;
                newItem.antecesor = arrayAux[intIndex].antecesor;
                newItem.sucesor = arrayAux[intIndex].sucesor;
                newItem.type = arrayAux[intIndex].type;
                newItem.qty = qty;
                newItem.numPartAntecesor = arrayAux[intIndex].numPartAntecesor;
                newItem.numPartSucesor = arrayAux[intIndex].numPartSucesor;
                newItem.priceLista = arrayAux[intIndex].priceLista;
                newItem.priceCore = "$" + this.subFormatMoney(priceUnitario) + " MXN";;
                newItem.priceCoreCF = arrayAux[intIndex].priceCoreCF;
                newItem.isDeleted = false;
                newItem.itemType = new ItemType()

              
                switch (intFlag) {
                    case 0:
                        itemToPush = newItem;
                        arrayAux[intIndex].isDeleted = true;
                        break;
                    case 1:
                        itemToPush = newItem.sucesor;
                        arrayAux[intIndex].sucesor.isDeleted = true;
                        break;
                    case 2:
                        newItem.itemId = newItem.antecesor.itemId;
                        newItem.numPart = newItem.antecesor.numPart;
                        newItem.stock = newItem.antecesor.stock;
                        newItem.description = newItem.antecesor.description;
                        newItem.name = newItem.antecesor.name;
                        newItem.type = "antecesor";
                        newItem.qty = newItem.qty;
                        newItem.numPartAntecesor = newItem.antecesor.numPartAntecesor;
                        newItem.numPartSucesor = newItem.antecesor.numPartSucesor;
                        newItem.priceLista = newItem.antecesor.priceLista;
                        newItem.priceCore = newItem.priceCore;
                        newItem.priceCoreCF = newItem.antecesor.priceCoreCF;
                        newItem.antecesor = undefined;
                        newItem.sucesor = undefined;
                        newItem.isDeleted = false;
                        newItem.itemType = new ItemType()
                        itemToPush = newItem;
                        arrayAux[intIndex].antecesor.isDeleted = true;
                        break;
                    
                    default:
                        break;
                    }
                    
                arrayAux.push(itemToPush);

                this.setState({
                    arrayItems: arrayAux,
                })           

            $('#modal-add-edit-item-ant').modal('hide');
            $('#modal-item-edit-ok').modal('show');
            }
        });

        
        
    }


    existItem(e) {

        var numpart = $('#num_parte').val().trim();
        numpart = numpart.replaceAll(",", "");
        var qty = $('#qtyedit').val();
        $('#btn-valreg').prop("disabled", false);
        this.boolIsNewItem = true;

        if (numpart == "" || qty == 0) {
            Toastr.warning('Completa los campos para validar registro', 'Campos requeridos');
            return;

        }

        if (this.state.arrayItemsIssues.find(item => item.numPart == numpart)) {
            Toastr.warning('El No. de parte ya se encuentra agregado.', 'Duplicación de registro');
            return
        }

        if (this.state.arrayItems.find(item => item.numPart == numpart)) {
            Toastr.warning('El No. de parte ya se encuentra agregado.', 'Duplicación de registro');
            return
        } else if (this.state.arrayItems.find(item => item.antecesor != undefined && item.antecesor.numPart == numpart)) {
            Toastr.warning('El No. de parte ya se encuentra agregado como sugerencia.', 'Sugerido');
            return
        } else if (this.state.arrayItems.find(item => item.sucesor != undefined && item.sucesor.numPart == numpart)) {
            Toastr.warning('El No. de parte ya se encuentra agregado como sugerencia.', 'Sugerido');
            return
        }


        var arrItemsToEdit = [];

        arrItemsToEdit.push({
            numPart: numpart.toUpperCase(),
            qty: qty
        });

        this.validateItems(arrItemsToEdit);
        $('#modal-add-edit-item').modal('hide');
        $('#modal-item-edit-ok').modal('show');
    }

    // Component Qty 
    updateItemQuantity(item, strDeltaType) {

        let salesUnit = item.salesUnit != undefined ? parseInt(item.salesUnit) : 1;
        console.log("salesUnit" + salesUnit);
        var strInputId_I = item.itemId != undefined ? item.itemId : item.numPart;
        var input = $("#qty-" + strInputId_I);        
        var isOverFlowStock = false;
        var intValueUnit = 0;          
        
        var intInputValue = 0;
        if (
            !isNaN(input.val())
        ) {
            intInputValue = parseInt(input.val());
        }
        
        if (intInputValue == 0) {
            intValueUnit = salesUnit;
        }
        else if (intInputValue > 0) {
            if (this.isMultiple(input.val(), salesUnit)) {
                intValueUnit = salesUnit;
            } else {

                if (intInputValue < salesUnit) {
                    intInputValue = 0;
                    if (strDeltaType == "plus") {
                        intValueUnit = salesUnit;
                    } else {
                        intValueUnit = salesUnit;
                    }
                } else {

                    // Arrays que contendran los valores multiples de salesUnit
                    let multiples_salesUnit = [];

                    var aux = input.val() * salesUnit;

                    // bucle del 1 a aux
                    for (var i = 1; i <= aux; i++) {

                        if (this.isMultiple(i, salesUnit)) {

                            multiples_salesUnit.push(i);
                        };

                        for (let index = 0; index < multiples_salesUnit.length; index++) {
                            const element = multiples_salesUnit[index];

                            if (input.val() < element) {
                                intInputValue = 0;
                                intValueUnit = element;
                                break;
                            }
                        }
                    }
                }
            }
        }

        if (
            strDeltaType == "plus"
        ) {
            intInputValue += intValueUnit;

            if (item.type == "antecesor" && intInputValue > item.stock) {
                isOverFlowStock = true;
            }

        }
        else if (
            strDeltaType == "minus"
        ) {
            intInputValue -= intValueUnit;
        }

        /*if (intInputValue == 0) {
            intInputValue = salesUnit;
        }*/

        if (
            intInputValue > 0 && intInputValue >= salesUnit 
            )
        {
            //Update UI, not allowed negative values
            if (
                intInputValue >= 0 && !isOverFlowStock
            ) {
                input.prop("disabled", false);
                input.val(intInputValue);
                //input.text(intInputValue);
                input.prop("disabled", true);

            }
        }
        else
        {
            this.showDeleteItemModalConfimationUnit(strInputId_I);
        }

    }

    isMultiple(quantity, unit) {

        var boolIsMultiple = false;
        var resto = quantity % unit;

        if (resto == 0) {
            boolIsMultiple = true;
        } else {
            boolIsMultiple = false;
        }
        return boolIsMultiple;
    } 

    // Modal modal-availability
    displayModal(itemName, modalId, num_parte, stock) {
        this.userAddress = this.getCookie('SelectedAddress');
        this.getTableData(undefined, num_parte).then(rows => {


            if (rows.length > 0) {
                $('#modal-availability #modalBody table>tbody')[0].innerHTML = rows;
            }
            else {
                $('#modal-availability #modalBody table>tbody')[0].innerHTML = `<tr>
                    <td>No hay existencias disponibles.</td>
                    <td>-</td>
                       </tr>`;
            }
        });
        this.setState({ "headerItem": itemName });
        $(`#${modalId}`).modal({ 'show': true });
    }

    loadSucursales() {
        var self = this;
        const promiseSucursales = new Promise((resolve, reject) => {
            const options = {
                pluginId: self.packageIdAlmacenes,
                tableName: "Almacenes",
                query: [
                    {
                        Name: 'IsActive',
                        Operator: "eq",
                        Value: "true"
                    }
                ]
            };

            client.CustomTables.searchCustomTable(options, function (err, result) {
                resolve(result);
            });
        });

        const promiseUserConfiguration = new Promise((resolve, reject) => {
            const options = {
                pluginId: self.packageIdAlmacenes,
                tableName: "ConfiguracionUsuario",
                query: [{
                    Name: "UserId",
                    Operator: "equal",
                    Value: this.props.user.ID
                },
                {
                    Name: "AddressId",
                    Operator: "equal",
                    Value: this.state.strCookieAddressId
                }
                ]
            };

            client.CustomTables.searchCustomTable(options, function (err, result) {
                resolve(result);
            });
        });

        Promise.all([promiseSucursales, promiseUserConfiguration]).then(response => {
            let sucursales = this.modalsorting(response[0], response[1]);
            this.sucursales = sucursales;
            this.userConfig = response[1].Records.length > 0 ? response[1].Records : [];


        });


    }

    getTableData(jsonItem, num_parte) {
        let self = this;
        return new Promise((resolve, reject) => {
            const promiseSucursales = new Promise((resolve, reject) => {
                const options = {
                    pluginId: self.packageIdAlmacenes,
                    tableName: "Almacenes",
                    query: [
                        {
                            Name: 'IsActive',
                            Operator: "eq",
                            Value: "true"
                        }
                    ]
                };

                client.CustomTables.searchCustomTable(options, function (err, result) {
                    resolve(result);
                });
            });

            const promiseUserConfiguration = new Promise((resolve, reject) => {
                const options = {
                    pluginId: self.packageIdAlmacenes,
                    tableName: "ConfiguracionUsuario",
                    query: [{
                        Name: "UserId",
                        Operator: "equal",
                        Value: this.props.user.ID
                    },
                    {
                        Name: "AddressId",
                        Operator: "equal",
                        Value: this.state.strCookieAddressId
                    }
                    ]
                };

                client.CustomTables.searchCustomTable(options, function (err, result) {
                    resolve(result);
                });
            });

            //TODO: poner en partcode del CF correspondiente
            const requestBody = {
                "operatingUnitId": 446,// esto debe ir fijo
                //"depotID": 7201, // esto se debe de quitar en una proximo update de endpoint
                "partsCode": [
                    {
                        "partCode": jsonItem != undefined ? jsonItem.itemNum : num_parte // TODO: esto debe ser una propiedad del item
                    }
                ]
            };

            const promiseapilider = client.Availability.GetAvalability(requestBody);

            Promise.all([promiseSucursales, promiseapilider, promiseUserConfiguration]).then(response => {
                //TODO: mostrar toda la existencia si no tiene config
                //this.state.sucursalesCt = this.modalsorting(response[0], response[2]);
                let sucursales = this.modalsorting(response[0], response[2]);

                let rows = '';

                //TODO: hacer logica para hacer match de los stock de cada uno
                if (response[2].TotalRecords == 1 && response[1].Parts != undefined/*&& response[1].parts.length > 0*/) {
                    let userConfig = response[2].Records[0];
                    let liderPart = response[1].Parts[0]; // debe ser solo una porque se busca sdolamente esta
                    this.state.stockLider = response[1].Parts[0].Availabilitys;

                    this.extendAvailability = userConfig.VisibilidadExtentidaLiderId.split(','); // generate array of lider id.

                    this.onlyAvailability = userConfig.VisibilidadExistenciasLiderId.split(','); // generate array of lider id.


                    this.hasUserConfig = true;
                } else if (response[2].TotalRecords == 0 && response[1].Parts != undefined) {
                    let userConfig = response[2].Records[0];
                    this.state.stockLider = response[1].Parts[0].Availabilitys;
                    this.hasUserConfig = false;
                }
                let aux = 0;

                sucursales.forEach(element => {

                    let stock = this.getStockAvailability(element.LiderId);

                    let stockOnly = this.getOnlyStockAvailability(element.LiderId);

                    if (jsonItem) { }

                    if (this.extendAvailability.includes(`${element.LiderId}`)) {
                        rows += `<tr key=${element.LiderId} id=${element.LiderId}>
                    <td id=${element.LiderId}>${element.Nombre}</td>
                    <td id="availability">${stock}</td>
                    </tr>`
                    }

                    if (stockOnly > 0) {
                        if (jsonItem) {
                            aux += stockOnly;
                        }
                    }
                });

                if (jsonItem) {
                    if (aux == 0) {
                        jsonItem.stock = 0;
                    } else {
                        jsonItem.stock = aux;
                    }
                    resolve(jsonItem)

                } else {
                    resolve(rows);
                }

            });
        });
    }

    modalsorting(almacenes, userConfig) {
        if (userConfig.TotalRecords > 0) {
            let myRegion = almacenes.Records.find(x => x.Nombre == userConfig.Records[0].AlmacenFacturacion);

            let almacenesdemiregion = []
            almacenes.Records.forEach(x => {
                if (x.Region == myRegion.Region) {
                    almacenesdemiregion.push(x);
                }
            });

            let almacenesdenomiregion = []
            almacenes.Records.forEach(x => {
                if (x.Region != myRegion.Region) {
                    almacenesdenomiregion.push(x);
                }
            });

            almacenesdemiregion.sort((x, y) => this.NameSortFunction(x, y));
            almacenesdenomiregion.sort((x, y) => this.NameSortFunction(x, y));

            let ordenamiento = almacenesdemiregion.concat(almacenesdenomiregion);

            return ordenamiento;

        } else {
            let ordenamiento = almacenes.Records.sort((x, y) => this.NameSortFunction(x, y));

            return ordenamiento;
        }
    }

    NameSortFunction(x, y) {
        if (x.Nombre > y.Nombre) {
            return 1;
        }
        if (x.Nombre < y.Nombre) {
            return -1;
        }
        // x must be equal to y
        return 0;
    }

    getStockAvailability(depotId) {
        let availability = 0;
        let depot;

        if (this.state.stockLider != undefined) {
            depot = this.state.stockLider.find(x => x.DepotId == Number(depotId));

            if (depot != undefined && this.hasUserConfig == true) {
                //render just if is in the config table
                if (this.extendAvailability != undefined) {
                    if (this.extendAvailability.includes(`${depot.DepotId}`)) {
                        availability = depot.Availability;
                    }
                //} else {
                //    blockUI();
                }
            }

        }

        else if (depot != undefined && this.hasUserConfig == false) {
            availability = depot.Availability
        } else {
            availability = 0;
        }

        return availability;
    }

    getStockAvailabilityCF(depotId) {
        let availability = 0;
        let depot;

        if (this.disponibilidadAlmacenes != undefined) {
            depot = this.disponibilidadAlmacenes.find(x => x.DepotId == Number(depotId));

            if (depot != undefined && this.hasUserConfig == true) {
                //render just if is in the config table
                if (this.extendAvailability != undefined) {
                    if (this.extendAvailability.includes(`${depot.DepotId}`)) {
                        availability = depot.Availability;
                    }
                //} else {
                //    blockUI();
                }
            }

        }

        else if (depot != undefined && this.hasUserConfig == false) {
            availability = depot.Availability
        } else {
            availability = 0;
        }

        return availability;
    }

    getOnlyStockAvailability(depotId) {
        let availability = 0;
        let depot;

        if (this.state.stockLider != undefined) {
            depot = this.state.stockLider.find(x => x.DepotId == Number(depotId));

            if (depot != undefined && this.hasUserConfig == true) {
                //render just if is in the config table
                if (this.onlyAvailability != undefined) {
                    if (this.onlyAvailability.includes(`${depot.DepotId}`)) {
                        availability = depot.Availability;
                    }
                //} else {
                //    blockUI();
                }
            }

        }

        else if (depot != undefined && this.hasUserConfig == false) {
            availability = depot.Availability
        } else {
            availability = 0;
        }

        return availability;
    }

    getCookie(name) {
        if(typeof window !== 'undefined'){
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
        }
    }

    getAddressIdFromCookies() {
        //var addressId = this.getCookie('SelectedAddress');
        var addressId = $('#address-name').attr('addressid');
        if (addressId != null) {
            //console.log("address cookie found " + addressId);
            this.setState({ "strCookieAddressId": addressId })

        }
    }

    addressChanged() {
        //Este metodo debe ser invocado una vez que las existencias se han cargado y mostrado en UI por primera vez
        //asi como al finalizar el calculo de las existencias cada que el addresId cambia
        var addressId = $('#address-name').attr('addressid');
        if (
            this.state.strCookieAddressId != null && addressId != this.state.strCookieAddressId
        ) {
            //Actualizar el nuevo addressId al state 
            this.setState({ "strCookieAddressId": addressId })


            //Reload selected Address widget
            //this.subSetOptionAddressSelected();

            //TODO: Recalcular existencias contra el nuevo addressId, una vez recalculado y pintado en UI las existencias
            //este metodo: addressChanged() deberia ser llamado de nuevo
        }
        else {
            //Recursive method called every 1 second
            setTimeout(() => {
                this.addressChanged();
            }, 1000)
        }
    }

    loadSalePrices() {

        return new Promise((resolve, reject) => {

            if (this.props.user.Guest == false) {
                var self = this;
                let userType = this?.props?.user?.CustomFields != null ? this?.props?.user?.CustomFields.find(cf => cf.Name == "Tipo de Usuario")?.Values[0] : null;
                let externalUserId =
                    this.props.user.CustomFields != null ? this.props.user.CustomFields.find(cf => cf.Name == "Cliente ID") : null
                //To test: 
                //let externalUserId = { Values: ["215"] };

                //This id is taken from the widget.
                //To test: 
                //var depotId = "11"; 
                var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");

                const priceParams = {
                    deptoId: depotId,
                    //MXN currency by default
                    currencyCode: "MXN",
                    customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                    //by default order type is PROGRAMADO
                    orderTypeCode: userType != null && userType === "B2C" ? "PEDIDOS INTERNET" : "PROGRAMADO",
                    detail: this.arrOfNumParts
                };

                client.BepensaPrices.getBepensaPricesByPartNumbers(priceParams).then(response => {
                    if (
                        response.Result != undefined && response.Result == 0 &&
                        response.PartsCode != undefined && response.PartsCode.length > 0
                    ) {

                        response.PartsCode.forEach(function (part, index) {
                            var partNumber = part.PartCode;
                            var salePrice = null;
                            var corePrice = null;
                            if (part.PartsPrices != null && part.PartsPrices[0] != null && part.PartsPrices[0].SalePrice != null) {
                                salePrice = part.PartsPrices[0].SalePrice;
                                if (part.PartsPrices[0].CorePart != null && part.PartsPrices[0].CorePart.SalePrice != null) {
                                    corePrice = part.PartsPrices[0].CorePart.SalePrice
                                }
                               

                                //If match with any item in state.arrayItems update his value
                                self.state.arrayItems.forEach((item, index) => {

                                    if (item.numPart == partNumber) {

                                        var currencyHeader = document.getElementById("exchange-currency").innerText;
                                        
                                        if (salePrice != null) {
                                            self.state.arrayItems[index].priceCore = "$" + self.subFormatMoney(salePrice) + " MXN";
                                        } else {

                                            if (self.state.arrayItems[index].priceUnit == "USD") {
                                                var priceCalculate = currencyHeader * self.state.arrayItems[index].priceLista;
                                                self.state.arrayItems[index].priceCore = "$" + self.subFormatMoney(priceCalculate) + " MXN";


                                            } else {
                                                self.state.arrayItems[index].priceCore = "$" + self.subFormatMoney(self.state.arrayItems[index].priceLista) + " MXN";

                                            }
                                        }
                                    }
                                });
                            }
                        });
                        self.forceUpdate();
                        //Unlock the view
                        $.unblockUI();
                    } else {
                        self.state.arrayItems.forEach((item, index) => {
                            self.state.arrayItems[index].priceCore = "$" + self.subFormatMoney(self.state.arrayItems[index].priceLista) + " MXN";
                            resolve(self.state.arrayItems[index].priceCore);
                        });
                        Toastr.warning("No se pudieron obtener/actualizar los precios de estos artículos, inténtelo más tarde");
                        //Unlock the view
                        $.unblockUI();
                    }
                });
            }
        });
    }

    getPriceUnitarioPromise(arrOfNumParts) {
        return new Promise((resolve, reject) => {
            if (this.props.user.Guest == false) {
                var self = this;
                let userType = this?.props?.user?.CustomFields != null ? this?.props?.user?.CustomFields.find(cf => cf.Name == "Tipo de Usuario")?.Values[0] : null;
                let externalUserId =
                this.props.user.CustomFields != null ? this.props.user.CustomFields.find(cf => cf.Name == "Cliente ID") : null
                var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");

                const priceParams = {
                    deptoId: depotId,
                    currencyCode: "MXN",
                    customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                     orderTypeCode: userType != null && userType === "B2C" ? "PEDIDOS INTERNET" : "PROGRAMADO",
                    detail: arrOfNumParts
                };

                client.BepensaPrices.getBepensaPricesByPartNumbers(priceParams).then(response => {
                    if (
                        response.Result != undefined && response.Result == 0 &&
                        response.PartsCode != undefined && response.PartsCode.length > 0
                    ) {
                        resolve(response);
                    }
                });
            }
        });
    }

    getPriceUnitario(numParte){
        return new Promise((resolve, reject) => {
        let arrNumPartes = [];
        arrNumPartes.push({ "partCode": numParte });
        let price = 0;

        this.getPriceUnitarioPromise(arrNumPartes).then(response =>{
            response.PartsCode.forEach(function (part, index) {            
                var salePrice = null;
                var corePrice = null;
                if (part.PartsPrices != null && part.PartsPrices[0] != null && part.PartsPrices[0].SalePrice != null) {
                    salePrice = part.PartsPrices[0].SalePrice;
                    price = salePrice;
                    /*if (part.PartsPrices[0].CorePart != null && part.PartsPrices[0].CorePart.SalePrice != null) {
                        corePrice = part.PartsPrices[0].CorePart.SalePrice
                        price = corePrice;
                    }*/
                }                               
                    resolve(price);
            });
        });
     });        
    }

    subFormatMoney(
        numAmount_I,
        intDecimalCount = 2,
        strDecimal = ".",
        strThousands = ","
    ) {
        try {
            intDecimalCount = Math.abs(intDecimalCount);
            intDecimalCount = isNaN(intDecimalCount) ? 2 : intDecimalCount;

            const negativeSign = numAmount_I < 0 ? "-" : "";

            let str_Z = parseInt(numAmount_I = Math.abs(Number(numAmount_I) || 0).toFixed(intDecimalCount)).toString();
            let str_Z2 = (str_Z.length > 3) ? str_Z.length % 3 : 0;

            return negativeSign + (str_Z2 ? str_Z.substr(0, str_Z2) + strThousands : '') +
                str_Z.substr(str_Z2).replace(/(\d{3})(?=\d)/g, "$1" +
                    strThousands) + (intDecimalCount ? strDecimal +
                        Math.abs(numAmount_I - str_Z).toFixed(intDecimalCount).slice(2) : "");
        } catch (e) {
            //console.log(e)
        }
    }

    deleteAllItems(
        boolStartProcess_I
    ) {
        if (
            boolStartProcess_I
        ) {
            $.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Vaciando Pedido Ágil...' });
        }

        let arrayAux = this.state.arrayItems;
        let arrayIssuesAux = this.state.arrayItemsIssues;

        if (this.state.arrayItems) {

            for (let index = 0; index < arrayAux.length; index++) {
                const element = arrayAux[index];
                $('#' + element.itemId).remove();
            }

        }
        if (this.state.arrayIssuesAux) {

            for (let index = 0; index < arrayIssuesAux.length; index++) {
                const element = arrayIssuesAux[index];
                console.log(element.numPart);
                $('#' + element.numPart).remove();
            }
        }

        var table = document.getElementById("dataOk");
        var rows = table.getElementsByTagName("tr");

        if (rows.length > 1) {
            for (var i = 1; i < rows.length; i++) {
                var currentRow = table.rows[i];
                var idItem = currentRow.getAttribute("id");
                $('#' + idItem).remove();
            }

        }

        $.unblockUI();

        this.setState({
            arrayItems: [],
            deleteitems: true,
            arrayItemsIssues: []
        });
        this.forceUpdate();

    }
    
    fillTableErrors (arrData){ 
        $('#blockMessage').empty();
        var table = document.getElementById("import-error-table").getElementsByTagName('tbody')[0]; 
        for (let index = 0; index < arrData.length; index++) {
                var tableRow = table.insertRow(-1);
                var numPart = tableRow.insertCell(0);
                const elementNP = arrData[index].numPart;           
                const elementQty = arrData[index].qty;
                numPart.innerHTML = elementNP + '\t' + elementQty + '\n';           
        }

        $('#modal-item-addcar').modal('show'); 
        $.unblockUI();
    }

    copyData(event){
        var codigoACopiar = document.getElementById('tbody-errors');       
        var seleccion = document.createRange(); 
        seleccion.selectNodeContents(codigoACopiar);   
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(seleccion); 
        document.execCommand('copy'); 
        window.getSelection().removeRange(seleccion);
               
        $('#modal-item-addcar').modal('hide'); 
        $.blockUI({ css: { backgroundColor: '#D1D2D4' }, message: 'Redireccionando a carrito...' });
        window.location = '/cart'
    }

    populateTableIssues() {
        const self = this;
        var arrayItemTable = [];
        var boolIsSugEmpty = true;
        var boolIsIssuesEmpty = true;

        this.state.arrayItems.map(function (item) {
            if (item.boolSugAntecesor()) {
                var itemtr = <tr id={item.antecesor.numPart}>
                    <td>{item.numPart}</td>
                    <td>Existencia insuficiente -<label type="text" id="customfields" className="numOrder"> Parte antecesora: {item.antecesor.numPart}</label></td>

                    <td>
                        <div className="bp-quantity-controls">
                            <div className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item.antecesor, "minus")}>-</div>

                            <div><input type="text" id={"qty-" + item.antecesor.itemId} value={item.quantitySugAntecesor()} disabled></input></div>

                            <button id="moreIssues" className="bp-quantity-control-box " onClick={() => self.updateItemQuantity(item.antecesor, "plus")}>+</button>
                        </div>

                    </td>



                    <td><a href="#" onClick={(e) => self.displayModal(item.name, "modal-availability", item.antecesor.numPart, item.antecesor.stock)}>{item.antecesor.stock}</a></td>
                    <td>
                        <div className="item-actions">
                            <a href={null}><i key={1} className="icon icon-addcar" onClick={() => self.showItemAddEdit(item.antecesor.itemId, item.antecesor.numPart, item.antecesor.qty, "move", item.antecesor.type)}></i></a>
                            <a href={null} className="delete_item"><i key={2} className="icon icon-delitem" onClick={(e) => self.showDeleteRow(item.antecesor.itemId)}></i></a>

                        </div>
                    </td>
                </tr>;

                if (!item.antecesor.isDeleted) {
                    boolIsSugEmpty = false;
                    arrayItemTable.push(itemtr);
                }
            }

        });

        {
            this.state.arrayItemsIssues.length > 0 &&
                this.state.arrayItemsIssues.map(function (item) {
                    var itemNotFound = <tr id={item.numPart}>
                        <td>{item.numPart}</td>
                        <td>Parte no encontrada</td>
                        <td>
                            <div className="bp-quantity-controls">
                                <div className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item, "minus")}>-</div>
                                <div><input type="text" id={"qty-" + item.numPart} value={parseInt(item.qty)} disabled></input></div>
                                <div className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item, "plus")}>+</div>
                            </div>
                        </td>
                        <td ><a>{item.stock}</a></td>
                        <td>
                            <div className="item-actions">
                                <a href={null}><i key={1} className="icon icon-edititem" onClick={() => self.showItemAddEdit(item.itemId, item.numPart, item.qty, "edit", item.type)}></i></a>
                                <a href={null} className="delete_item"><i key={1} className="icon icon-delitem" onClick={(e) => self.showDeleteRoIssues(item.numPart.trim())}></i></a>
                            </div>
                        </td>
                    </tr>;
                    if (!item.isDeleted) {
                        boolIsIssuesEmpty = false;
                        arrayItemTable.push(itemNotFound);
                    }

                });
        }

        return (
            <div id="issuesTable" className={boolIsIssuesEmpty && boolIsSugEmpty ? "hide" : "tableIssues"}>
                <h4 className="title-section" align="left">Observaciones</h4>
                <table id="issuesdata">
                    <thead >
                        <tr>
                            <th>Número de parte</th>
                            <th>Motivo</th>
                            <th>Cantidad</th>
                            <th>Existencias</th>
                            <th> Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {arrayItemTable}
                    </tbody>

                </table>
            </div>
        );
    }



    populateTableDataMain() {
        var self = this;
        var arrayItemTable = [];

        this.state.arrayItems.map(function (item) {

          /*  if (item.priceCore == 0) {
                var priceLista = "$" + item.priceLista + " MXN";
                item.priceCore = priceLista;
            }*/

            if (item.sucesor == undefined && item.antecesor == undefined) {
                //si esta condición se cumple significa que viene de la tabla de sugeridos.

                var itemtr = <tr id={item.itemId} data-key="item" data-id={item.itemId}>
                    <td>{item.numPart}</td>
                    <td>
                        <div className="content_img">
                            {item.name}
                            <div>{item.desc}</div>
                        </div>
                    </td>

                    <td>
                        <div className="bp-quantity-controls">
                            <div className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item, "minus")}>-</div>
                            <div><input type="text" id={"qty-" + item.itemId} value={parseInt(item.qty)} disabled></input></div>
                            <button id="moreDetails" className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item, "plus")}>+</button>
                        </div>
                    </td>
                    <td><a href="#" onClick={(e) => self.displayModal(item.name, "modal-availability", item.numPart, item.stock)}>{item.stock}</a></td>

                    
                    <td>{item.priceCore}</td>
                    <td>{item.priceCoreCF}</td>
                    <td ><a href="#" className="delete_item"><i key={3} className="icon icon-delitem" onClick={(e) => self.showDeleteRow(item.itemId)}></i></a></td>
                </tr>;

                if (!item.isDeleted) {
                    arrayItemTable.push(itemtr);
                }


            } else {//En el else se validan todos los items que vinieron de las promesas
                var itemtr = <tr id={item.itemId} data-key="item" data-id={item.itemId}>
                    <td>{item.numPart}</td>
                    <td>
                        <div className="content_img">
                            {item.name}
                            <div>{item.desc}</div>
                        </div>
                    </td>

                    <td>
                        {item.type == "antecesor" &&

                            <div className="bp-quantity-controls">
                                <div className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item, "minus")}>-</div>
                                <div><input type="text" id={"qty-" + item.itemId} defaultValue={item.getQuantity()} disabled></input></div>
                                <button id="moreDetails" className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item, "plus")}>+</button>
                            </div>
                        }

                        {item.type != "antecesor" &&

                            <div className="bp-quantity-controls">
                                <div className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item, "minus")}>-</div>
                                <div><input type="text" id={"qty-" + item.itemId} defaultValue={item.getQuantity()} disabled></input></div>
                                <button id="moreDetails" className="bp-quantity-control-box styleplus" onClick={() => self.updateItemQuantity(item, "plus")}>+</button>
                            </div>
                        }

                    </td>
                    <td><a href="#" onClick={(e) => self.displayModal(item.name, "modal-availability", item.numPart, item.stock)}>{item.stock}</a></td>

                    <td>{item.priceCore}</td>
                    <td>{item.priceCoreCF}</td>
                    <td ><a href="#" className="delete_item"><i key={3} className="icon icon-delitem" onClick={(e) => self.showDeleteRow(item.itemId)}></i></a></td>
                </tr>;
                if (!item.boolIsAntecesorStockEmpty() && item.boolIsAntecesor() && !item.isDeleted) {
                    arrayItemTable.push(itemtr);
                } else if (item.boolIsSupercesor() && !item.isDeleted) {
                    arrayItemTable.push(itemtr);
                }

                if (!item.boolIsSameSucesor() && item.boolSugSucesor() && item.boolShowSugSucesor()) {

                    var itemtrSucesor = <tr id={item.sucesor.itemId} data-key="item" data-id={item.sucesor.itemId}>
                        <td>{item.sucesor.numPart}</td>
                        <td>
                            <div>
                                <label className="numOrder"> Supercede al NP {item.numPart}</label>
                                <div>{item.desc}</div>
                            </div>
                        </td>

                        <td>
                            <div className="bp-quantity-controls">
                                <div className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item.sucesor, "minus")}>-</div>
                                <div><input type="text" id={"qty-" + item.sucesor.itemId} defaultValue={item.quantitySugSucesor()} disabled></input></div>
                                <button id="moreDetails" className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item.sucesor, "plus")}>+</button>
                            </div>
                        </td>
                        <td><a href="#" onClick={(e) => self.displayModal(item.name, "modal-availability", item.sucesor.numPart, item.sucesor.stock)}>{item.sucesor.stock}</a></td>

                        <td>{item.priceCore}</td>
                        <td>{item.priceCoreCF}</td>
                        <td ><a href="#" className="delete_item"><i key={3} className="icon icon-delitem" onClick={(e) => self.showDeleteRow(item.sucesor.itemId)}></i></a></td>
                    </tr>;
                    if (!item.sucesor.isDeleted) {
                        arrayItemTable.push(itemtrSucesor);
                    }

                }
            }



        });

        return arrayItemTable;
    }

    populateTableDetailMain() {
        document.getElementById("titleHeader").style.display = 'none';
        return (
            <div id="dataprocess" className="tableProcess">
                {this.state.arrayItems.length > 0 &&
                    <div id="detailTable" className="tableDetail">
                        <div className='container-headerdetail' >
                            <div>
                                <h4 className="title-section" align="left">Pedido ágil</h4>
                            </div>
                            <div id="div-destroy-cart" className="bp-grid-cart del-table-agil" onClick={() => { this.deleteAllItems(true, 0) }}>
                                <div className="destroy-cart-label">
                                    <label>Vaciar Pedido ágil</label>
                                </div>
                                <div className='destroy-cart-img'>
                                    <img
                                        style={{ width: 25, height: 20 }}
                                        src="/assets/images/bepensa/trashbin.svg"></img>
                                </div>
                            </div>
                        </div>
                        <table id="dataOk" key={"ok"}>
                            <thead>
                                <tr>
                                    <th>Número de parte</th>
                                    <th>Descripción</th>
                                    <th>Cantidad</th>
                                    <th>Existencias</th>
                                    <th>Precio de cliente</th>
                                    <th>Precio CORE</th>
                                    <th>Borrar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.populateTableDataMain()}
                            </tbody>
                        </table>
                    </div>
                }

                {this.state.deleteitems == true &&
                    <div id="detailTable" className="tableDetail">
                        <div className='container-headerdetail' >
                            <div>
                                <h4 className="title-section" align="left">Pedido ágil</h4>
                            </div>
                            <div id="div-destroy-cart" className="bp-grid-cart del-table-agil" onClick={() => { this.deleteAllItems(true, 0) }}>
                                <div className="destroy-cart-label">
                                    <label>Vaciar Pedido ágil</label>
                                </div>
                                <div className='destroy-cart-img'>
                                    <img
                                        style={{ width: 25, height: 20 }}
                                        src="/assets/images/bepensa/trashbin.svg"></img>
                                </div>
                            </div>
                        </div>
                        <table id="dataOk" key={"ok"}>
                            <thead>
                                <tr>
                                    <th>Número de parte</th>
                                    <th>Descripción</th>
                                    <th>Cantidad</th>
                                    <th>Existencias</th>
                                    {<th>Precio Lista</th>}
                                    <th>Precio de cliente</th>
                                    <th>Borrar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.populateTableDataMain()}
                            </tbody>
                        </table>
                    </div>
                }

                <div className="actions" id="btn-actions-order-agil">
                    <input className="btn-addcar" type="submit" onClick={() => this.showItemAddEdit("", "", "0", "add", "")} value="Agregar producto" />
                    <input className="btn-passcar" type="submit" onClick={(e) => this.addItemsCar(e)} value="Pasar a Carrito" />
                </div>
                <div>
                    {this.populateTableIssues()}
                </div>
                <div className="actions-copy">
                    <input className="btn-addcar" type="submit" />
                    <input className="btn-passcar" type="submit" />
                </div>

                <div id="modalRemove" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog delete-modal-content">
                        <div className="modal-content">
                            <div className="modal-body">
                                <p>¿Estás seguro que quieres borrar?</p>
                            </div>
                            <div className="modal-footer">
                                <div className="btn-gray" data-dismiss="modal">No</div>
                                <div className="btn-green" id="btnRemove" onClick={(e) => this.doItemDelete()}>Si</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="modalRemoveI" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog delete-modal-content">
                        <div className="modal-content">
                            <div className="modal-body">
                                <p>¿Estás seguro que quieres borrar?</p>
                            </div>
                            <div className="modal-footer">
                                <div className="btn-gray" data-dismiss="modal">No</div>
                                <div className="btn-green" id="btnRemoveIssues" onClick={(e) => this.doItemDeleteIssues()}>Si</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="modal-add-edit-item" className="modal fade x-boot-modal" role="dialog">
                    <div className="modal-dialog" id="sub-modal-add-edit-item">
                        <form method="POST" id="frm-comparison" action="javascript:void(0);">
                            {/* Modal content */}
                            <div className="modal-content" id="modal-edit-order-agil">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                    <h4 id="modal-title-order-agil" className="modal-title modal-tittle-custom" align="left">{this.state.titleModal}</h4>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <div className="modaledit">
                                            <div>
                                                <div id="inputs-container-order-agil">
                                                    <div className="item-container-order-agil">
                                                        <span className="lbl-modal-order-agil">Número de parte</span>
                                                        <input type="text" name="num_parte" id="num_parte" className="form-control required input-modal-order-agil" />
                                                    </div>
                                                    <div className="item-container-order-agil">
                                                        <span className="lbl-modal-order-agil">Cantidad</span>
                                                        <input type="number" name="num_parte" id="qtyedit" className="form-control required input-modal-order-agil" />
                                                    </div>
                                                </div>
                                                {/*<table>
                                                    <thead>
                                                        <th>
                                                            <label htmlFor="num_parte">Número de parte</label>
                                                        </th>
                                                        <th>
                                                            <label htmlFor="qtyedit">Cantidad</label>
                                                        </th>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input type="text" name="num_parte" id="num_parte" className="form-control required" />
                                                            </td>
                                                            <td>
                                                                <input type="number" name="num_parte" id="qtyedit" className="form-control required" />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                */}
                                            </div>
                                            <div className="modal-footer text-center">
                                                <input type="submit" id = "btn-valreg"  className="btn-valreg" onClick={(e) => this.existItem()} value="Validación de registro" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div id="modal-add-edit-item-ant" className="modal fade x-boot-modal" role="dialog">
                    <div className="modal-dialog">
                        <form method="POST" id="frm-comparison" action="javascript:void(0);">
                            {/* Modal content */}
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                    <h4 className="modal-title" align="center">{this.state.titleModal}</h4>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <div className="modaledit">
                                            <div>
                                                <div id="inputs-container-order-agil">
                                                    <div className="item-container-order-agil">
                                                        <span className="lbl-modal-order-agil">Número de parte</span>
                                                        <input type="text" name="num_parte" id="num_parteant" className="form-control required input-modal-order-agil" />
                                                    </div>
                                                    <div className="item-container-order-agil">
                                                        <span className="lbl-modal-order-agil">Cantidad</span>
                                                        <input type="number" name="num_parte" id="qtyeditant" className="form-control required input-modal-order-agil" />
                                                    </div>
                                                </div>
                                                {/*
                                                <table>
                                                    <thead>
                                                        <th>
                                                            <label className="lbl-modal-order-agil" htmlFor="num_parte">Número de parte</label>
                                                        </th>
                                                        <th>
                                                            <label className="lbl-modal-order-agil" htmlFor="qtyedit">Cantidad</label>
                                                        </th>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input type="text" name="num_parte" id="num_parteant" className="form-control required input-modal-order-agil" />
                                                            </td>
                                                            <td>
                                                                <input type="number" name="num_parte" id="qtyeditant" className="form-control required input-modal-order-agil" />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                */}
                                            </div>
                                            <div className="modal-footer text-center">
                                                <input type="submit" id = "btn-valregant" className="btn-valreg" onClick={(e) => this.existItemAntecesor()} value="Validación de registro" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="modal fade" id="modal-availability" tabIndex="-1" role="dialog" aria-labelledby="userEditorLabel" aria-hidden="true" style={{ display: "none" }}>
                    <div className="modal-dialog" style={{ maxWidth: 800 + 'px' }} role="document">
                        <div className="modal-content" style={{ borderRadius: 25 + 'px' }}>
                            <div className="modal-header" style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px', borderBottom: 'none' }} >
                                <h5 className="modal-title col-md-11" id="userEditorLabel" style={{ fontWeight: "bold", fontSize: 23 + 'px' }} >{this.state.headerItem}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body" id="modalBody" style={{ marginBottom: 25 + 'px', marginLeft: 25 + 'px', marginRight: 25 + 'px' }}>
                                <table className="table" id="exis">
                                    <thead>
                                        <tr style={{ background: "white", borderColor: '#f0f0f0', borderTopStyle: "solid" }}>
                                            <th scope="col">Sucursal</th>
                                            <th scope="col">Existencias</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">Cargando</th>
                                            <td>-</td>
                                        </tr>
                                        {/* {this.renderTable()} */}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="modalRemoveFromPedidoUnit" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog delete-modal-content">
                    <div className="modal-content">
                        <div className="modal-body">
                             <p className="text-center">Por la configuración de unidad de venta del producto no es posible disminuir la cantidad. ¿Estás seguro de continuar?</p>                        
                        </div>
                        <div className="modal-footer">
                            <input type="hidden" id="ipt-itemToDelete" defaultValue=""></input>
                            <div className="btn-gray btndeletepopup" data-dismiss="modal">Cancelar</div>
                            <div className="btn-green" id="btnRemoveItemUnit" onClick={(e) => this.doItemDelete()}>Eliminar del carrito</div>
                        </div>
                    </div>
                </div>
            </div>
                <div className="modal fade" id="modal-item-addcar" tabIndex="-1" role="dialog" aria-labelledby="userEditorLabel" aria-hidden="true" style={{ display: "none" }}>
                    <div className="modal-dialog" style={{ width: 500 + 'px' }} role="document">
                        <div className="modal-content" style={{ borderRadius: 25 + 'px' }}>
                            <div className="modal-header" style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px', borderBottom: 'none' }} >
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body" id="modalBody" style={{maxHeight: 500 +'px',overflow:'auto'}}>
                                <div style ={{margin: 20 + 'px'}} id="">
                                    <div className="row" id="error-table">
                                        <table className="table table-sort" style ={{textAlign: 'center'}} id="import-error-table">
                                            <thead className="thead-dark">
                                            <tr>
                                                <th style={{fontSize: 16 + 'px'}} scope="col">Números de parte sin procesar</th>
                                            </tr>
                                            </thead>
                                            <tbody id="tbody-errors">
                                            
                                            </tbody>
                                        </table>
                                    </div>
                                </div> 
                            </div>
                            <div className="modal-footer" style={{display:'flex'}}>                                   
                                    <div className="btn-addcar" id="btnRemove" onClick={(e) => this.copyData(e)}>Copiar</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="modal-item-edit-ok" tabIndex="-1" role="dialog" aria-labelledby="userEditorLabel" aria-hidden="true" style={{ display: "none" }}>
                    <div className="modal-dialog" style={{ width: 500 + 'px' }} role="document">
                        <div className="modal-content" style={{ borderRadius: 25 + 'px' }}>
                            <div className="modal-header" style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px', borderBottom: 'none' }} >
                            <h4 id="modal-title-order-agil" className="modal-title modal-tittle-custom" align="left">Tu registro ha sido actualizado exitosamente!</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            </div>
                            <div className="modal-body" id="modalBody" style={{maxHeight: 500 +'px',overflow:'auto'}}>
                                <div style ={{margin: 20 + 'px'}} id="">
                                    <p>
                                        El registro ha sido agregado automaticamente a la tabla 
                                        de pedido ágil. </p>
                                    <p> Para verificarlo, favor de buscar el último registro.</p>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }

    renderTable() {
        return (
            <div>
                <div id="inputdata">
                    <div>
                        <textarea className="main-textarea" id="textarea" rows={this.state.taValue.split('\n').length > 5 ? this.state.taValue.split('\n').length : 5} name="textarea" placeholder=" + Copia y pega el número de parte y su cantidad correspondiente." value={this.state.taValue} onChange={this.handleChange} />
                    </div>
                    <div id="contnr-btn-validate-cart-agil"><button type="submit" className="btn-initial" id="btn-validate-cart-agil"onClick={(e) => this.getDataTable(e)}>Validar Carrito </button> </div>
                </div>
                <div id="tableData" className="tableInitial">
                    <div id="tableDatacopy" className="datacopy">
                        <div className="datacopyname text-center"> Número de Parte</div>
                        <div className="datacopyqty text-center"> Cantidad</div>
                    </div>
                    <div className="content-tablemain table-responsive">
                        <table id="tablemain" className="table">
                            <thead>
                                <tr hidden>
                                    <th className="text-center">Número de parte</th>
                                    <th className="text-center">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>
                    <div><button id="process" className="btn-process" type="submit" onClick={(e) => this.validateItems(this.state.inputData)}> Validar Carrito </button></div>
                    <div><button id="process-movil" className="btn-process" type="submit"> Validar Carrito </button></div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <div id="main-container-agil" className="main-container">
                    <div id="titleHeader" className="title"><h3>Pedido ágil</h3>
                        {/*<div className="icon icon-help divider" ></div>*/}
                    </div>
                    <div> {!this.state.boolShowTable && descHeader1}</div>
                    <div> {!this.state.boolShowTable && descHeader2}</div>
                    <div> {this.state.boolShowTable && this.populateTableDetailMain()} </div>
                    <div> {!this.state.boolShowTable && this.renderTable()} </div>
                    <span id="blockMessage" ></span>
                </div>
                <div className="availability">
                </div>
            </div>
        );
    }
}
module.exports = OrderAgilComponent